var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRawMaterial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.433,
    height: 13.574,
    viewBox: "0 0 21.433 13.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raw_material",
    "data-name": "Raw material",
    transform: "translate(0 -87.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86513",
    "data-name": "Path 86513",
    d: "M243.069,92.413c-1.61,0-2.851,1.751-3.573,3.188a.357.357,0,0,0,.049.393,1.464,1.464,0,0,0,.844.566c2.318.271,3.162,1.834,3.906,3.213a8.873,8.873,0,0,0,1.466,2.16.36.36,0,0,0,.255.107h2.375a.357.357,0,0,0,.326-.5C247.336,98.463,245.638,92.413,243.069,92.413Zm-.544,3.023-.223.268a.357.357,0,0,1-.549-.457l.223-.268a.357.357,0,1,1,.549.457Zm1.206,1.474-.223.268a.357.357,0,0,1-.549-.457l.223-.268a.357.357,0,0,1,.549.457Z",
    transform: "translate(-228.766 -4.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86514",
    "data-name": "Path 86514",
    d: "M21.433,325.075v.893a1.073,1.073,0,0,1-1.072,1.072H1.072A1.073,1.073,0,0,1,0,325.968v-.893A1.073,1.073,0,0,1,1.072,324H20.361A1.073,1.073,0,0,1,21.433,325.075Z",
    transform: "translate(0 -225.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86515",
    "data-name": "Path 86515",
    d: "M39.737,93.05C37.565,92.8,36.99,87.929,34.47,88c-2.652.066-3.778,6.125-4.934,9.346a.357.357,0,0,0,.337.477H43.606a.357.357,0,0,0,.3-.558C42.669,95.458,42.316,93.352,39.737,93.05Zm-6.8,2.409-.223.268a.357.357,0,0,1-.549-.457L32.387,95a.357.357,0,0,1,.549.457Zm.938-2.5-.223.268a.357.357,0,0,1-.549-.457l.223-.268a.357.357,0,0,1,.549.457Zm1.206,1.92-.223.268a.357.357,0,0,1-.549-.457l.223-.268a.357.357,0,0,1,.549.457Z",
    transform: "translate(-28.197 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawMaterial);
export default __webpack_public_path__ + "static/media/raw_material.ae83b36d80844eb05d1c364f241637d5.svg";
export { ForwardRef as ReactComponent };